export const FUNGIBALL_V1 = "Fungiball_v1";
